import {AnyAction} from 'redux'
import {getOrder} from '../actions/placed-order'
import {SEND_RSVP_OLD, sendRsvp} from '../actions/rsvp'

export const calendarLinks = (state = null, action: AnyAction) => {
  switch (action.type) {
    case SEND_RSVP_OLD.SUCCESS:
    case sendRsvp.fulfilled.toString():
    case getOrder.fulfilled.toString():
      return {
        ...action.payload.calendarLinks,
      }
    default:
      return state
  }
}
